import type { ReactNode } from "react";

export function EmptyState({ title, children, action }: { title: string; children?: ReactNode; action?: ReactNode }) {
  return <div className="bw-area-empty"><h2>{title}</h2>{children && <p>{children}</p>}{action}</div>;
}
